import PropTypes from 'prop-types';
import FileCard from './FileCard';

const FileGrid = ({ files, onPreview, onDownload }) => (
  <div className="file-grid">
    {files.map((file) => (
      <FileCard
        key={file.id}
        file={file}
        onPreview={onPreview}
        onDownload={onDownload}
      />
    ))}
  </div>
);

FileGrid.propTypes = {
  files: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  })).isRequired,
  onPreview: PropTypes.func,
  onDownload: PropTypes.func,
};

FileGrid.defaultProps = {
  onPreview: undefined,
  onDownload: undefined,
};

export default FileGrid;
